import { INVOICES_URL, SALE_ORDER_URL } from "../../CONSTANTS";
import { SYSTEM_ERROR } from "../../config/CONSTANTS";
import axios from "axios";
import Cookies from "universal-cookie";



const headersdata = {
    "content-type": "application/json",
    Accept: "application/json",
    get Authorization() {
        const cook = new Cookies().get("loginData1");
        return cook !== undefined ? cook.accessToken : "";
    }
    // 'Authorization': url.Auth_Token
};

export const confirmOrDraftSalesOrder = (id) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .put(SALE_ORDER_URL() + "confirmOrDraftSalesOrder/" + id, id, {
                    headers: headersdata,
                })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in confirmOrDraftSalesOrder axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const getSalesOrderBySalesPersonId1 = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(SALE_ORDER_URL() + "getSalesOrderBySalesPersonId", data, {
                    headers: headersdata,
                })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getSalesOrderBySalesPersonId axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const getSalesByInvoiceNo1 = (id) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .get(SALE_ORDER_URL() + "getSalesByInvoiceNo/" + id, {
                    headers: headersdata,
                })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getSalesByInvoiceNo axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const getSalesOrderByItemId1 = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(SALE_ORDER_URL() + "getSalesOrderByItemId", data, {
                    headers: headersdata,
                })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const getSalesOrderByCustomerId1 = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(SALE_ORDER_URL() + "getSalesOrderByCustomerId", data, {
                    headers: headersdata,
                })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};


export const getSalesOrderList = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(SALE_ORDER_URL() + "getAllRecords", data, {
                    headers: headersdata,
                })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};
export const getSalesOrderListByWareHouse = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(SALE_ORDER_URL() + "getRecordsByWarehouseId", data, {
                    headers: headersdata,
                })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const addSalesOrder = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(SALE_ORDER_URL(), data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const getSalesOrderDetail = (id) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .get(SALE_ORDER_URL() + id, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemDetail axios!");
                });
        } catch (error) {
            console.error("in LoginService > getItemDetail, Err===", error);
            reject(SYSTEM_ERROR);
        }
    });
};

export const getSalesOrderNoByCustomerUUID = (id) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .get(SALE_ORDER_URL() + "getKeyValueListByCustomer/" + id, {
                    headers: headersdata,
                })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getSalesOrderNoByCustomerUUID axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const updateSalesOrder = (id, data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .put(SALE_ORDER_URL() + id, data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const updateSalesOrderItemByPriceListUid = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .put(
                    SALE_ORDER_URL() + "updateSalesOrderItemByPriceListUid",
                    data,
                    { headers: headersdata }
                )
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(
                        "Error in updateSalesOrderItemByPriceListUid axios!"
                    );
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const convertToInvoice = (id, data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .put(SALE_ORDER_URL() + id, data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};
export const getHSNReport = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(INVOICES_URL() + "getItemsSoldByHsnIdcustomerId", data, {
                    headers: headersdata,
                })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getSalesOrderListByHsn axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};
export const getPurchaseReport = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(INVOICES_URL() + "getItemsPurchaseReport", data, {
                    headers: headersdata,
                })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemsPurchaseReport axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const multipleSalesOrder = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(SALE_ORDER_URL() + "getMultipleSalesOrder", data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};


export const multipleSalesSave = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(SALE_ORDER_URL() + "saveMultipleSalesOrder", data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const getSalesMarginReport = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(INVOICES_URL() + "salesMarginReport", data, {
                    headers: headersdata,
                })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in salesMarginReport axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};
